import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const defaultSize = 30;

const ImageIcon = ({ imageSource, ...props }) => {
    const canvasRef = useRef();

    useEffect(() => {
        updateCanvas();
    }, [imageSource]);

    const updateCanvas = () => {
        const canvas = canvasRef.current;
        if (!canvas) {
            return;
        }

        const ctx = canvas.getContext('2d');
        if (!ctx || !imageSource) {
            return;
        }

        // Reset canvas when updating, otherwise previous drawings remain
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        const img = new Image();
        img.src = imageSource.toString();
        img.onload = () => {
            const scaleFactor = Math.min(defaultSize / img.width, defaultSize / img.height);
            const [dW, dH] = [img.width * scaleFactor, img.height * scaleFactor];
            const [dX, dY] = [(defaultSize - dW) / 2, (defaultSize - dH) / 2];
            ctx.drawImage(img, dX, dY, dW, dH);
        };
    };

    return (
        <canvas
            ref={canvasRef}
            width={defaultSize}
            height={defaultSize}
            data-testid={props['data-testid']}
        />
    );
};

ImageIcon.propTypes = {
    imageSource: PropTypes.instanceOf(URL),
    'data-testid': PropTypes.string
};

ImageIcon.defaultProps = {
};

export default ImageIcon;
